import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Provider.Find.IRequest;
type Response = Api.Core.Provider.Find.IResponse;
type Headers = Api.Core.Provider.Find.IHeaders;
const url = '/api/ProductManagement/Provider/:id';
export default async function providerFindApi(params: { id: number }): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, params),
    headers: getDefaultHeaders(),
  });
}
